import styled from "styled-components";

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #f4f6f8;
  color: #fff;
  position: fixed;
  bottom: 0;
`;
interface FooterButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  color: string;
}
export const FooterButtonWrapper = styled.div<{padding: string}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding:  ${(props) => (props.padding ? props.padding : "10px 20px")};
`;
export const FooterButton = styled.button<FooterButtonProps>`
  display: flex;
  align-items: center;
  border-radius: 99px;
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
  border: none;
  padding: 6px 20px;
  color: ${(props) => (props.color ? props.color : "#fff")};
  font-family: "Archivo-Regular";
  height: 40px;
  text-transform: uppercase;
  cursor: pointer;
  &:hover {
    transition: all 0.2s;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
  @media (max-width: 768px) {
    height: 30px;
    padding: 2px 10px;
    font-size: 12px;
  }
`;

interface FooterInfoProps {
  isMobile: boolean;
}
export const FooterInfo = styled.p<FooterInfoProps>`
  font-size: 14px;
  color: #2c2c2c;
  font-weight: bold;
  padding: 0px 5px 10px 5px;
  display: ${(props) => (props.isMobile ? "none" : "block")};
  @media (max-width: 768px) {
    padding: 5px 5px 0px 5px;
    font-size: 12px;
    display: ${(props) => (props.isMobile ? "flex" : "none")};
    gap: 5px;
    align-items: center;
  }
`;

export const SectionModalSeq = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  gap: 5px;
  color: #2c2c2c;
  > h1 {
    padding-bottom: 10px;
    font-family: "Archivo-Bold";
  }
  > h4, p {
    text-align: center;
    font-family: "Archivo-Semibold";
  }
  > p {
    text-align: center;
    max-width: 300px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  grid-gap: 10px;
  padding: 10px;
  width: 100%;
`;
export const SelectFooter = styled.select`
  padding: 5px 10px;
  border-radius: 99px;
  cursor: pointer;
  width: fit-content;
`;
